// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 954) return "subsite-china/954-170f4e928e1dc2523d1e.js";
	if (chunkId === 532) return "subsite-china/styles-4eaeceb620afdd1ebc91.js";
	if (chunkId === 351) return "subsite-china/commons-cb5dbd4b6aef11e6629c.js";
	if (chunkId === 875) return "subsite-china/190f48e1d712abf1b23afe7d98d0424ba15cabee-7782abbb8134fc1bc823.js";
	if (chunkId === 218) return "subsite-china/component---src-pages-404-tsx-bf71646d6d250fbb51e7.js";
	if (chunkId === 278) return "subsite-china/b0c88c5e5b54854a066ab8be45f25781c5307858-ca862508084b53831821.js";
	if (chunkId === 904) return "subsite-china/2d1c9d34d7cabdcdf27eb8ffad16bade3b93f9b1-0cebaa0c53edf3163b0f.js";
	if (chunkId === 660) return "subsite-china/component---src-templates-personal-area-calendar-page-index-tsx-0a5637bc9d3b861d1bd7.js";
	if (chunkId === 456) return "subsite-china/8bd7444894d603c816394f87921cda61ce72b74b-e5660d9ec7f4c237d4ab.js";
	if (chunkId === 874) return "subsite-china/component---src-templates-personal-area-profile-page-index-tsx-4aae24e66e591b711c77.js";
	if (chunkId === 323) return "subsite-china/component---src-templates-qr-index-tsx-b602dbdf61c5b12d0280.js";
	if (chunkId === 77) return "subsite-china/component---src-templates-search-page-index-tsx-33079f0075466614e7cf.js";
	if (chunkId === 737) return "subsite-china/fb7d5399-579775acb6a8620619b4.js";
	if (chunkId === 863) return "subsite-china/072d4843-f500a61f39e89e73ebc3.js";
	if (chunkId === 208) return "subsite-china/2aacc723-2d704e856e93ce9f7770.js";
	if (chunkId === 344) return "subsite-china/bf322c48-b177f07f883de55c559b.js";
	if (chunkId === 811) return "subsite-china/22e32791-f14c2a4d3244157a5910.js";
	if (chunkId === 312) return "subsite-china/409a021e-d87a124adfe3ecf5d2b7.js";
	if (chunkId === 125) return "subsite-china/b2d36f25-100e8fc373561af878b5.js";
	if (chunkId === 255) return "subsite-china/7d0bf13e-494c8d08ff9d3fccaf66.js";
	if (chunkId === 330) return "subsite-china/component---src-templates-standard-page-index-tsx-c0badfe3827b46cf156d.js";
	if (chunkId === 731) return "subsite-china/731-59b00b79190c6499edd9.js";
	if (chunkId === 843) return "subsite-china/843-c7a8b9edab11e967c894.js";
	// return url for filenames based on template
	return undefined;
};